import React from "react";
import logo from '../assets/images/logo2.PNG'
import { Link } from "react-router-dom";

const Footer = () => {
  const date = new Date().getFullYear();
  return (
    <>
      <footer class="bg-primary dark:bg-gray-900">
        <div class=" w-full p-6 py-6 lg:py-8 px-6 sm:px-6 md:px-6 lg:px-16 xl:px-32">
          <div class="md:flex md:justify-between">
            <div class="mb-6 md:mb-0">
              <Link to="/" class="flex items-center mb-2" >
                <img  onClick={()=>window.scrollTo(0,0)}
               src={logo} 
               className="h-10 w-45 object-fill"
               alt=" Logo"
                />
              </Link>
              <p className="w-[330px] sm:w-[300px] lg:w-[400px] text-gray-400 p-2 text-sm">
              At my core, I am a dynamic developer and designer driven by a fervent passion for creativity. I specialize in crafting powerful online presences that not only showcase your work but also weave a compelling narrative around it. My mission is to empower creative minds to shine brightly and tell their unique stories through exceptional digital experiences.              </p>
            </div>
            <div class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
              <div>
                <h2 class="mb-6 text-sm font-semibold uppercase text-white">
                  Resources
                </h2>
                <ul class="text-gray-500 dark:text-gray-400 text-sm">
                  <li class="mb-4"  onClick={()=>window.scrollTo(0,0)}>
                    <Link to="/" class="hover:underline">
                      Awais Ahmad
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h2 class="mb-6 text-sm font-semibold uppercas text-white">
                  FOLLOW US
                </h2>
                <ul class="text-gray-500 dark:text-gray-400 text-sm">
                  <li class="mb-4">
                    <a target="_blank" rel="noreferrer"
                      href="https://github.com/Awais-514"
                      class="hover:underline "
                    >
                      Github
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h2 class="mb-6 text-sm font-semibold uppercase text-white">
                  Quik Links
                </h2>
                <ul class="text-gray-500 dark:text-gray-400 text-sm">
                  <li class="mb-4"  onClick={()=>window.scrollTo(0,0)}>
                    <Link
                      to="/case-studies"
                      class="hover:underline"
                    >
                      Projects
                    </Link>
                  </li>
                  <li onClick={()=>window.scrollTo(0,0)}>
                    <Link
                      to="/my-expertise"
                      class="hover:underline"
                    >
                      Expertise
                    </Link>
                  </li>
                </ul>
              </div>
              {/* <div>
                <h2 class="mb-6 text-sm font-semibold uppercase text-white">
                  Legal
                </h2>
                <ul class="text-gray-500 dark:text-gray-400 text-sm">
                  <li class="mb-4">
                    <a href="https://www.nitensclue.com" class="hover:underline">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a href="https://www.nitensclue.com" class="hover:underline">
                      Terms &amp; Conditions
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
          <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8 lg:mx-3" />
          <div class="sm:flex sm:items-center sm:justify-between px-20">
            <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">
              © {date} {""}
              <Link to="/" class="hover:underline"  onClick={()=>window.scrollTo(0,0)}>
                Awais Ahmad™
              </Link>
              . All Rights Reserved.
            </span>
            <div class="flex mt-4 sm:justify-center sm:mt-0">
              <a target="_blank" rel="noreferrer"
                href="https://www.facebook.com/mian.awais.514"
                class="text-gray-500 hover:text-gray-900 dark:hover:text-white"
              >
                <svg
                  class="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 8 19"
                >
                  <path
                    fill-rule="evenodd"
                    d="M6.135 3H8V0H6.135a4.147 4.147 0 0 0-4.142 4.142V6H0v3h2v9.938h3V9h2.021l.592-3H5V3.591A.6.6 0 0 1 5.592 3h.543Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="sr-only">Facebook page</span>
              </a>

              <a rel="noreferrer"
                href="https://www.linkedin.com/in/awaisahm3d"
                target="_blank"
                className="text-gray-500 hover:text-gray-900 dark:hover:text-white ms-5"
              >
                <svg
                  width="24" // Adjust width as needed
                  height="24" // Adjust height as needed
                  viewBox="0 0 1920 1920"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" // Ensure it uses current text color
                  className="w-4 h-4" // Tailwind classes for sizing
                  aria-hidden="true"
                >
                  <path d="M478.234 600.75V1920H.036V600.75h478.198Zm720.853-2.438v77.737c69.807-45.056 150.308-71.249 272.38-71.249 397.577 0 448.521 308.666 448.521 577.562v737.602h-480.6v-700.836c0-117.867-42.173-140.215-120.15-140.215-74.134 0-120.151 23.55-120.151 140.215v700.836h-480.6V598.312h480.6ZM239.099 0c131.925 0 239.099 107.294 239.099 239.099s-107.174 239.099-239.1 239.099C107.295 478.198 0 370.904 0 239.098 0 107.295 107.294 0 239.099 0Z" />
                </svg>
                <span className="sr-only">LinkedIn</span>
              </a>

              <a rel="noreferrer"
                href="https://github.com/Awais-514"
                target="_blank"
                class="text-gray-500 hover:text-gray-900 dark:hover:text-white ms-5"
              >
                <svg
                  class="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 .333A9.911 9.911 0 0 0 6.866 19.65c.5.092.678-.215.678-.477 0-.237-.01-1.017-.014-1.845-2.757.6-3.338-1.169-3.338-1.169a2.627 2.627 0 0 0-1.1-1.451c-.9-.615.07-.6.07-.6a2.084 2.084 0 0 1 1.518 1.021 2.11 2.11 0 0 0 2.884.823c.044-.503.268-.973.63-1.325-2.2-.25-4.516-1.1-4.516-4.9A3.832 3.832 0 0 1 4.7 7.068a3.56 3.56 0 0 1 .095-2.623s.832-.266 2.726 1.016a9.409 9.409 0 0 1 4.962 0c1.89-1.282 2.717-1.016 2.717-1.016.366.83.402 1.768.1 2.623a3.827 3.827 0 0 1 1.02 2.659c0 3.807-2.319 4.644-4.525 4.889a2.366 2.366 0 0 1 .673 1.834c0 1.326-.012 2.394-.012 2.72 0 .263.18.572.681.475A9.911 9.911 0 0 0 10 .333Z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="sr-only">GitHub account</span>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer;
